/**
 * Prefer a clean slug, but ignore `null`, empty strings **and any string
 * that becomes empty after trim()**.  Fallback = documentId.
 */
export const slugOrId = (item) => {
      const raw = typeof item?.slug === "string" ? item.slug.trim() : "";
      return raw ? raw : item?.documentId;
    };